<div class="container pd-bottom-90" *ngIf="filteredProducts">
  <app-category-header
    [title]="categoryData.name"
    [imageUrl]="categoryData.theme.imageUrl"
  ></app-category-header>

  <div class="content">
    <div class="content-menu">
      <div class="categories">
        @for (item of listCategories; track item) {
          <button
            class="btn-category"
            (click)="setCategory(item)"
            [class.activate]="selectedCategory === item"
          >
            {{ item }}
          </button>
        }
      </div>

    <div class="products">
      @for (item of filteredProducts; track item) {
        <app-product-card
          [id]="item.id"
          [title]="item.name"
          [description]="item.description"
          [price]="item.price/100"
          [imageUrl]="item.imageUrl"
          [isFavorite]="item.isFavorite"
          [productData]="item"
        ></app-product-card>
      }
    </div>
    </div>
  </div>
</div>
